import axios from "axios";
import RefreshTokenHandler from "../refreshToken/refreshToken";
import Config from "../config";

export const getMessagesByChat = async (email, chat_id) => {
  try {
    const token = sessionStorage.getItem("token");
    const url = `${Config.baseUrl}/message/by-chat-id?email=${email}&chat_id=${chat_id}`;
    const result = await axios.get(url, {
      headers: {
        Authorization: token || "",
      },
    });
    return result;
  } catch (err) {
    if (err.response.data.status === 401 || err.response.status === 403) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getMessagesByChat(email, chat_id);
      } else {
        throw err.response;
      }
    } else {
      throw err.response;
    }
  }
};
